import { render, staticRenderFns } from "./accountMg.vue?vue&type=template&id=6c1702fe&scoped=true&"
import script from "./accountMg.vue?vue&type=script&lang=js&"
export * from "./accountMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1702fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1702fe')) {
      api.createRecord('6c1702fe', component.options)
    } else {
      api.reload('6c1702fe', component.options)
    }
    module.hot.accept("./accountMg.vue?vue&type=template&id=6c1702fe&scoped=true&", function () {
      api.rerender('6c1702fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/facebook/accountMg.vue"
export default component.exports